<div class="area-page-container">
    <!-- CHECKBOX AREA TYPE -->
    <div class="area-type">
        <div class="area-type-region">
            <mat-radio-group
                name="area-type"
                [(ngModel)]="selectedAreaType">
                <mat-radio-button [value]="0" [checked]="selectedAreaType">Region</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="area-type-department">
            <mat-radio-group
                name="rea-type"
                [(ngModel)]="selectedAreaType">
                <mat-radio-button [value]="1" >Department</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    
    <div class="area-type-form-content">
        <app-region *ngIf="selectedAreaType === 0"  [region]="region" (refresh)="refreshRegion()"></app-region>
        <app-department *ngIf="selectedAreaType === 1" [regionList]="regionList" [department]="department" (refresh)="refreshDepartment()"></app-department>
    </div>
</div>
<div class="area-list-container">
    <mat-tab-group [selectedIndex]="selectedAreaType" (selectedIndexChange)="selectedAreaType=$event">
        <mat-tab label="Region List">
            <app-region-list (regionChange)="regionList=$event" (editChange)="onRegionEdit($event)"></app-region-list>
        </mat-tab>
        <mat-tab label="Department List">
            <app-department-list [regionList]="regionList" (editChange)="onDepartmentEdit($event)"></app-department-list>
        </mat-tab>
      </mat-tab-group>
</div>